import {useAccountExecutiveContext} from '../account-executive-context';
import {useAsync} from 'react-use';
import {LeaseCompleteOfficersService} from '../api/generated';
import {Dropdown, DropdownItemProps} from 'semantic-ui-react';
import React, {useMemo} from 'react';
import css from '@emotion/css';
import {MobileaseTheme} from '../styles/branding';
import {sessionOfficerIdKey, sessionOfficerNameKey} from '../utils/constants';

type AccountExecutiveContextSelectorProps = {
  onValueChanged?: (value: string | undefined) => void;
};

export const AccountExecutiveContextSelector = (
  props: AccountExecutiveContextSelectorProps
) => {
  const {onValueChanged} = props;
  const [accountExecutiveContext, setAccountExecutiveContext] =
    useAccountExecutiveContext();

  const {value} = accountExecutiveContext;

  const getOptions = useAsync(async () => {
    const {data} =
      await LeaseCompleteOfficersService.getAccountExecutiveOptions();

    if (value) {
      const selectedOption = data?.find((x) => x.officerId == value);
      setAccountExecutiveContext({
        value: selectedOption?.officerId,
        name: selectedOption?.officerName,
      });
    } else {
      setAccountExecutiveContext({
        value: data?.[0]?.officerId,
        name: data?.[0]?.officerName,
      });
    }

    return data;
  }, []);

  const options = useMemo(
    () =>
      getOptions.value?.map((x) => ({
        key: `${x.officerId} ${x.officerName}`,
        text: (
          <div className={'text-container'}>
            <div>{x.officerName}</div>
            <div className="officer-label">Account Executive</div>
          </div>
        ),
        value: x.officerId,
        officerName: x.officerName,
      })),
    [getOptions.value]
  );

  const searchOptions = (options, searchQuery): DropdownItemProps[] => {
    return options?.filter((x) =>
      x.key.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };

  return (
    <div css={styles}>
      <Dropdown
        className="ae-selector"
        placeholder="Select Account Executive..."
        selection
        loading={getOptions.loading}
        value={value}
        icon="angle down"
        search={searchOptions}
        selectOnBlur={false}
        selectOnNavigation={false}
        onChange={(e, data) => {
          const officerId = data.value as string;
          const officerName = options?.find(
            (x) => x.value === data.value
          )?.officerName;

          setAccountExecutiveContext({
            value: officerId,
            name: officerName,
          });
          localStorage.setItem(sessionOfficerIdKey, `${officerId}`);
          localStorage.setItem(sessionOfficerNameKey, `${officerName}`);
          onValueChanged?.(officerId);
        }}
        options={options ?? []}
      />
    </div>
  );
};

const styles = css`
  // text-align: center;

  .ae-selector {
    .divider.default.text {
      color: ${MobileaseTheme.colors.grey500} !important;
    }

    .divider.text {
      width: 100%;
    }
    .menu.visible {
      width: 550px !important;
    }
    &.ui.selection.dropdown {
      background: ${MobileaseTheme.colors.grey50};
      border: 0;
      font-weight: 500;

      & .selected.item {
        background: rgba(0, 0, 0, 0.1);
      }
    }

    .text-container {
      display: flex;
      font-weight: 600;
      font-size: 1rem;
    }

    .officer-label {
      font-weight: 400;
      color: grey;
      margin-left: 1rem;
    }

    .angle.down.icon {
      color: ${MobileaseTheme.colors.blue400};
      cursor: pointer;
      position: absolute;
      width: auto;
      height: auto;
      line-height: 1.21428571em;
      top: 0.48em;
      right: 0.12em;
      z-index: 3;
      margin: -0.73333333em;
      padding: 0.91666667em;
      opacity: 0.8;
      transition: opacity 0.1s ease;
    }
  }
`;